import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  GetInsurancePlansByPatientId,
  GetPatientEligibilityDetails,
  CreateInsurancePlanByPatientId,
  DeleteInsurancePlanById,
  SetPrimaryInsurancePlanById,
  SetVerifiedOnInsurancePlanById,
} from '@services/api/insurance.api'
import { refreshFromPatient } from '@store/reducers/patientmanagement.reducer'

export const fetchInsurancePlansByPatientId = createAsyncThunk(
  'api/insurances/fetchInsurancePlansByPatientId',
  async (patientId: string) => {
    try {
      const response = await GetInsurancePlansByPatientId(patientId)

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        return response.data
      }

      return 'Insurance plan details not found'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)

export const checkPatientEligibility = createAsyncThunk(
  'api/insurances/checkPatientEligibility',
  async (formData: any) => {
    try {
      const response = await GetPatientEligibilityDetails(formData)

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        return response.data
      }

      return 'Insurance plan details not found'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)

export const addInsurancePlanByPatientId = createAsyncThunk(
  'api/insurances/addInsurancePlanByPatientId',
  async (
    {
      patientId,
      insuranceData,
    }: {
      patientId: string
      insuranceData: any
    },
    { dispatch },
  ) => {
    try {
      const response = await CreateInsurancePlanByPatientId(
        patientId,
        insuranceData,
      )

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        dispatch(refreshFromPatient())
        return response.data
      }

      return 'Insurance plan has not been created.'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)

export const deleteInsurancePlanById = createAsyncThunk(
  'api/insurances/deleteInsurancePlanById',
  async (insurancePlanId: string, { dispatch }) => {
    try {
      const response = await DeleteInsurancePlanById(insurancePlanId)

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        dispatch(refreshFromPatient())
        return response.data
      }

      return 'Insurance plan has not been deleted.'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)

export const setPrimaryInsurancePlanById = createAsyncThunk(
  'api/insurances/setPrimaryInsurancePlanById',
  async (insurancePlanId: string, { dispatch }) => {
    try {
      const response = await SetPrimaryInsurancePlanById(insurancePlanId)

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        dispatch(refreshFromPatient())
        return response.data
      }

      return 'Insurance plan has not been set as primary.'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)

export const setVerifiedOnInsurancePlanById = createAsyncThunk(
  'api/insurances/setVerifiedOnInsurancePlanById',
  async (insurancePlanId: string, { dispatch }) => {
    try {
      const response = await SetVerifiedOnInsurancePlanById(insurancePlanId)

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        dispatch(refreshFromPatient())
        return response.data
      }

      return 'Insurance plan has not been set as verified.'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)
